import { catalogFields } from './catalogRow';
import { columnIndex, findHeaderRowIndex } from './headers';
import { parseDspCell, regionFromFlatSheetName } from './parseDspCell';
import type { EatonPriceRow } from './types';

/** Already-flattened WJ-style sheet: catalogue rows with a DSP column. */
export function parseFlatPriceSheet(
  rows: unknown[][],
  fileName: string,
  sourceSheet: string,
): EatonPriceRow[] {
  const headerIndex = findHeaderRowIndex(rows, 'CATALOGUE');
  if (headerIndex < 0) return [];
  const header = rows[headerIndex];
  if (!header) return [];
  const region = regionFromFlatSheetName(sourceSheet);
  const prices: EatonPriceRow[] = [];
  for (const row of rows.slice(headerIndex + 1)) {
    const fields = catalogFields(header, row);
    const dsp = parseDspCell(row[columnIndex(header, 'DSP')]);
    if (fields.catalog === '' || dsp.spaId === '') continue;
    prices.push({
      fileName,
      sourceSheet,
      spaId: dsp.spaId,
      spaDescription: '',
      region,
      ...fields,
      location: dsp.location,
      customerCount: 0,
      coverageRegions: region,
    });
  }
  return prices;
}
